import styles from "./ChangeStatusModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ChevronDown } from "react-ikonate";
import { useState } from "react";
import { Modal } from "shared/Modal";

/**
 *
 * Modal used for confirmation of whitelist on the manage tab of the groups page.
 */

export function ChangeStatusModal({ isOpen, onClose, onClick, status }) {
  const [dropdownDropped, setDropdownDropped] = useState(false);

  const [statusLocal, setStatusLocal] = useState(
    status != null ? (status ? "Whitelist" : "Unwhitelist") : status
  );

  function clickItem(value) {
    setStatusLocal(value);
    setDropdownDropped(false);
  }

  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="CHANGE STATUS"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.description}>
              Whitelist a group so the sync will not remove members. Unwhitelist
              a group so the sync will remove members without plugins.
            </div>

            <div className={styles.selectLabel}>Status:</div>

            <div
              className={classNames(
                styles.select,
                dropdownDropped && styles.selectSelected,
                !dropdownDropped && statusLocal && styles.selectSelectedSelected
              )}
              onClick={() => setDropdownDropped(!dropdownDropped)}
            >
              <div
                className={classNames(
                  styles.icon,
                  dropdownDropped && styles.flippedIcon
                )}
              >
                <ChevronDown width={24} height={24} />
              </div>

              <div onClick={() => setStatusLocal(null)}>
                {dropdownDropped
                  ? "Select"
                  : !statusLocal
                  ? "OPTIONS"
                  : statusLocal}
              </div>

              {dropdownDropped && (
                <div className={styles.selectOptions}>
                  <div
                    className={styles.selectOption}
                    onClick={() => clickItem("Whitelist")}
                  >
                    Whitelist
                  </div>
                  <div
                    className={classNames(
                      styles.selectOption,
                      styles.bottomOption
                    )}
                    onClick={() => clickItem("Unwhitelist")}
                  >
                    Unwhitelist
                  </div>
                </div>
              )}
            </div>

            <div className={styles.buttonContainer}>
              <button
                className={classNames(styles.button, styles.cancelBtn)}
                onClick={onClose}
              >
                CANCEL
              </button>
              <button
                className={classNames(styles.button)}
                onClick={() =>
                  onClick(
                    statusLocal != null ? statusLocal == "Whitelist" : null
                  )
                }
              >
                CONFIRM
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

ChangeStatusModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  status: PropTypes.bool,
};
